import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Sidebar, Menu, Image } from 'semantic-ui-react';
import {
  HOME_ROUTE,
  FIND_CLUB_ROUTE,
  MY_ACCOUNT_ROUTE,
  CONTACT_ROUTE,
  ABOUT_ROUTE
} from '../../constants/route.constants';
import ClubSearch from '../Search/Navbar/ClubSearch';
import { DEFAULT_PROFILE_IMG } from '../../constants/profile.constants';

class NavBarMobileLoggedOut extends Component {
  render() {
    const user = this.props.user;
    const photo = user.photo || DEFAULT_PROFILE_IMG;
    return (
      <Sidebar
        as={Menu}
        animation="overlay"
        width="wide"
        direction="right"
        visible={this.props.isSidebarVisible}
        icon="labeled"
        vertical
        inverted
      >
        <Menu.Item name="profile">
          <Image avatar src={photo} /> {user.firstName}
        </Menu.Item>
        <Menu.Item
          name="signin"
          onClick={() => this.props.handleRouteChange(MY_ACCOUNT_ROUTE)}
        >
          My Account
        </Menu.Item>
        <Menu.Item
          name="about"
          onClick={() => this.props.handleRouteChange(ABOUT_ROUTE)}
        >
          About
        </Menu.Item>
        <Menu.Item
          name="home"
          onClick={() => this.props.handleRouteChange(FIND_CLUB_ROUTE)}
        >
          Find a club
        </Menu.Item>
        <Menu.Item
          name="contact"
          onClick={() => this.props.handleRouteChange(CONTACT_ROUTE)}
        >
          Contact Us
        </Menu.Item>
        <Menu.Item
          name="signout"
          onClick={() => {
            this.props.handleRouteChange(HOME_ROUTE);
            this.props.requestLogout();
          }}
        >
          Sign Out
        </Menu.Item>
        <Menu.Item>
          <ClubSearch {...this.props} />
        </Menu.Item>
      </Sidebar>
    );
  }
}

NavBarMobileLoggedOut.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

export default NavBarMobileLoggedOut;



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBarMobileLoggedIn.js